/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { sarsaparillaReducers, store as sarsaparillaStore } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth';

import { inventorySlugReducer } from 'ui-sitepass';
import {
    campingGatewayReducers,
    continueToExternalLinkReducers,
} from 'ui-camping/src/shared';
import { searchResultsReducers, searchAggregationsReducers } from 'ui-search';

import { mapReducer } from './map';
import { newGatewayReducers } from '../reducers';

const rootReducer = combineReducers({
    inventorySlugs: inventorySlugReducer,
    gateway: campingGatewayReducers,
    newGateway: newGatewayReducers,
    searchAggregations: searchAggregationsReducers,
    continueToExternalLink: continueToExternalLinkReducers,
    map: mapReducer,
    searchResults: searchResultsReducers,
    ...authReducers,
    ...sarsaparillaReducers,
});

export function setupStore(preloadedState?: any) {
    const newStore = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: [
                        'launchdarkly', // Has ld client object in reducer
                    ],
                },
            });
        },
        preloadedState,
        devTools: process.env.DEV_TOOLS_ENABLED,
    });

    return newStore;
}

const initialState = {
    ...sarsaparillaStore(),
};

export const store = setupStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

// cSpell:ignore reduxjs, sitepass
